module.exports = __webpack_public_path__ + "img/qr-code.07fa7001.png";